export const graphServer = `//${process.env.REACT_APP_API_DOMAIN}/graphql`;

export const delegateSite = `//training.${process.env.REACT_APP_API_DOMAIN}`;
export const managerSite = `//manager.${process.env.REACT_APP_API_DOMAIN}`;

export const delegateLogin = `${delegateSite}/login`;
export const managerLogin = `${managerSite}/login`;
